import React, { useState, useEffect } from 'react';
import { useApi } from '../../../hooks/useApi';
import logger from "../../../utils/logger";
import EntityCell from '../EntityCell';
import { filterBySearch } from '../../../utils/search';
import ConfirmByNameModal from '../../../components/ConfirmByNameModal';
import DeletedCabinets from '../../settings/DeletedCabinets';
// Списки админки отдаются страницами: забираем все, а не первые 100/1000.
async function loadAllPages(request, path, { pageSize = 200, offsetParam = 'offset' } = {}) {
  const rows = [];
  for (let offset = 0; ; offset += pageSize) {
    const sep = path.includes('?') ? '&' : '?';
    const page = (await request(`${path}${sep}limit=${pageSize}&${offsetParam}=${offset}`)) || [];
    rows.push(...page);
    if (page.length < pageSize) return rows;
  }
}

function AdminMarketplaces() {
  const {
    request,
    showStatus,
    fetchBlob
  } = useApi();
  const [accounts, setAccounts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [editingItem, setEditingItem] = useState(null);
  const [isCreateMode, setIsCreateMode] = useState(false);
  const [editForm, setEditForm] = useState({
    account_name: '',
    marketplace_type: 'ozon',
    api_key: '',
    seller_id: '',
    client_id: '',
    client_secret: '',
    is_active: true,
    company_id: '',
    owner_company_id: '',
    owner_user_id: ''
  });
  useEffect(() => {
    loadAccounts();
  }, []);
  const loadAccounts = async () => {
    setLoading(true);
    try {
      const data = await loadAllPages(request, '/api/v1/admin/marketplaces');
      setAccounts(data || []);
    } catch (error) {
      logger.error('Ошибка загрузки кабинетов', error);
    } finally {
      setLoading(false);
    }
  };
  const handleCreate = () => {
    setIsCreateMode(true);
    setEditingItem(null);
    setEditForm({
      account_name: '',
      marketplace_type: 'ozon',
      api_key: '',
      seller_id: '',
      client_id: '',
      client_secret: '',
      is_active: true,
      company_id: '',
      owner_company_id: '',
      owner_user_id: ''
    });
  };
  const handleEdit = acc => {
    setIsCreateMode(false);
    setEditingItem(acc);
    setEditForm({
      account_name: acc.account_name || '',
      marketplace_type: acc.marketplace_type || '',
      api_key: '********',
      // Masked
      seller_id: acc.seller_id || '',
      client_id: acc.client_id || '',
      client_secret: '********',
      // Masked
      is_active: acc.is_active !== false,
      company_id: acc.company_id || '',
      owner_company_id: acc.owner_company_id || '',
      owner_user_id: acc.owner_user_id || ''
    });
  };
  const handleSaveEdit = async e => {
    e.preventDefault();
    try {
      const payload = {
        ...editForm
      };
      if (isCreateMode) {
        await request('/api/v1/admin/marketplaces', {
          method: 'POST',
          body: JSON.stringify(payload)
        });
        showStatus('success', 'Кабинет создан');
      } else {
        // Remove masked passwords/keys if not changed
        if (payload.api_key === '********') delete payload.api_key;
        if (payload.client_secret === '********') delete payload.client_secret;
        await request(`/api/v1/admin/marketplaces/${editingItem.id}`, {
          method: 'PATCH',
          body: JSON.stringify(payload)
        });
        showStatus('success', 'Кабинет обновлен');
      }
      setEditingItem(null);
      setIsCreateMode(false);
      loadAccounts();
    } catch (error) {
      showStatus('error', 'Ошибка сохранения');
    }
  };
  const [deleteTarget, setDeleteTarget] = useState(null);
  const [deleteError, setDeleteError] = useState('');
  const [deleteBusy, setDeleteBusy] = useState(false);
  const handleDelete = id => {
    setDeleteError('');
    setDeleteTarget(accounts.find(item => item.id === id) || null);
  };
  const confirmDelete = async typedName => {
    setDeleteBusy(true);
    setDeleteError('');
    try {
      await request(`/api/v1/admin/marketplaces/${deleteTarget.id}?confirm_name=${encodeURIComponent(typedName)}`, {
        method: 'DELETE'
      });
      showStatus('success', 'Кабинет удален');
      setDeleteTarget(null);
      loadAccounts();
    } catch (error) {
      setDeleteError(error?.message || 'Ошибка удаления');
    } finally {
      setDeleteBusy(false);
    }
  };
  const getTypeLabel = type => {
    const labels = {
      ozon: 'OZON',
      wildberries: 'Wildberries',
      wb: 'Wildberries'
    };
    return labels[type] || type;
  };
  const getTypeColor = type => {
    const colors = {
      ozon: '#005bff',
      wildberries: '#cb11ab',
      wb: '#cb11ab'
    };
    return colors[type] || '#666';
  };
  return <div className="admin-page">
    {deleteTarget && <ConfirmByNameModal title="Удалить кабинет?" expectedName={deleteTarget.account_name} confirmLabel="Удалить кабинет" busy={deleteBusy} error={deleteError} onClose={() => setDeleteTarget(null)} onConfirm={confirmDelete} description={<p>Кабинет уйдёт в корзину на 30 дней (данные сохраняются), владельцу отправится письмо с копией данных. Восстановить можно ниже, в «Удалённые кабинеты и архивы».</p>} />}
    <details style={{ marginBottom: 16 }}><summary style={{ cursor: 'pointer', fontWeight: 600 }}>Удалённые кабинеты и архивы</summary><DeletedCabinets admin request={request} fetchBlob={fetchBlob} showStatus={showStatus} onChanged={loadAccounts} /></details>
            <div style={{
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: '20px'
    }}>
                <div>
                    <h1>Кабинеты маркетплейсов</h1>
                    <div style={{
          fontSize: '14px',
          color: '#666'
        }}>управление API-ключами и связями</div>
                </div>
                <div style={{
        display: 'flex',
        gap: '15px'
      }}>
                    <input type="text" placeholder="Поиск по названию или ID..." value={searchTerm} onChange={e => setSearchTerm(e.target.value)} style={{
          padding: '8px 15px',
          borderRadius: '6px',
          border: '1px solid #ddd',
          width: '300px'
        }} />
          
                    <button onClick={handleCreate} style={{
          padding: '10px 20px',
          background: '#27ae60',
          color: 'white',
          border: 'none',
          borderRadius: '6px',
          cursor: 'pointer',
          fontWeight: 'bold'
        }}>
            
                        + Добавить кабинет
                    </button>
                </div>
            </div>

            {/* Edit/Create Modal */}
            {(editingItem || isCreateMode) && <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: 'rgba(0,0,0,0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1000
    }}>
                    <div style={{
        background: 'white',
        padding: '30px',
        borderRadius: '12px',
        width: '600px',
        maxWidth: '95%',
        maxHeight: '90vh',
        overflowY: 'auto'
      }}>
                        <h2 style={{
          marginTop: 0
        }}>
                            {isCreateMode ? 'Новый кабинет' : `Параметры: ${editingItem.account_name}`}
                        </h2>
                        <form onSubmit={handleSaveEdit}>
                            <div style={{
            display: 'grid',
            gridTemplateColumns: '1fr 1fr',
            gap: '20px',
            marginBottom: '20px'
          }}>
                                <div>
                                    <label style={{
                display: 'block',
                marginBottom: '5px',
                fontWeight: 'bold'
              }}>Название</label>
                                    <input type="text" value={editForm.account_name} onChange={e => setEditForm({
                ...editForm,
                account_name: e.target.value
              })} style={{
                width: '100%',
                padding: '10px',
                border: '1px solid #ddd',
                borderRadius: '6px'
              }} required />
                
                                </div>
                                <div>
                                    <label style={{
                display: 'block',
                marginBottom: '5px',
                fontWeight: 'bold'
              }}>Тип МП</label>
                                    <select value={editForm.marketplace_type} onChange={e => setEditForm({
                ...editForm,
                marketplace_type: e.target.value
              })} style={{
                width: '100%',
                padding: '10px',
                border: '1px solid #ddd',
                borderRadius: '6px'
              }}>
                  
                                        <option value="ozon">OZON</option>
                                        <option value="wildberries">Wildberries</option>
                                    </select>
                                </div>
                            </div>

                            <div style={{
            background: '#f8f9fa',
            padding: '15px',
            borderRadius: '8px',
            marginBottom: '20px'
          }}>
                                <h3 style={{
              marginTop: 0,
              fontSize: '16px'
            }}>API Credentials</h3>
                                {editForm.marketplace_type === 'ozon' ? <>
                                        <div style={{
                display: 'grid',
                gridTemplateColumns: '1fr 1fr',
                gap: '10px',
                marginBottom: '10px'
              }}>
                                            <div>
                                                <label style={{
                    display: 'block',
                    fontSize: '12px',
                    fontWeight: 'bold'
                  }}>Seller ID (Ozon ID)</label>
                                                <input type="text" value={editForm.seller_id} onChange={e => setEditForm({
                    ...editForm,
                    seller_id: e.target.value
                  })} placeholder="123456" style={{
                    width: '100%',
                    padding: '8px',
                    border: '1px solid #ddd',
                    borderRadius: '4px'
                  }} required={editForm.marketplace_type === 'ozon'} />
                                            </div>
                                            <div>
                                                <label style={{
                    display: 'block',
                    fontSize: '12px',
                    fontWeight: 'bold'
                  }}>API Key (Seller API)</label>
                                                <input type="password" value={editForm.api_key} onChange={e => setEditForm({
                    ...editForm,
                    api_key: e.target.value
                  })} placeholder="••••••••" style={{
                    width: '100%',
                    padding: '8px',
                    border: '1px solid #ddd',
                    borderRadius: '4px'
                  }} required={isCreateMode} />
                                            </div>
                                        </div>
                                        <div style={{
                display: 'grid',
                gridTemplateColumns: '1fr 1fr',
                gap: '10px',
                marginBottom: '10px'
              }}>
                                            <div>
                                                <label style={{
                    display: 'block',
                    fontSize: '12px',
                    fontWeight: 'bold'
                  }}>Performance ID (Client ID)</label>
                                                <input type="text" value={editForm.client_id} onChange={e => setEditForm({
                    ...editForm,
                    client_id: e.target.value
                  })} placeholder="perf_123" style={{
                    width: '100%',
                    padding: '8px',
                    border: '1px solid #ddd',
                    borderRadius: '4px'
                  }} required={editForm.marketplace_type === 'ozon'} />
                                            </div>
                                            <div>
                                                <label style={{
                    display: 'block',
                    fontSize: '12px',
                    fontWeight: 'bold'
                  }}>Performance Secret</label>
                                                <input type="password" value={editForm.client_secret} onChange={e => setEditForm({
                    ...editForm,
                    client_secret: e.target.value
                  })} placeholder="••••••••" style={{
                    width: '100%',
                    padding: '8px',
                    border: '1px solid #ddd',
                    borderRadius: '4px'
                  }} required={isCreateMode} />
                                            </div>
                                        </div>
                                    </> : <div style={{
              marginBottom: '10px'
            }}>
                                        <label style={{
                display: 'block',
                fontSize: '12px',
                fontWeight: 'bold'
              }}>Standard API Key</label>
                                        <input type="password" value={editForm.api_key} onChange={e => setEditForm({
                ...editForm,
                api_key: e.target.value
              })} placeholder="••••••••" style={{
                width: '100%',
                padding: '8px',
                border: '1px solid #ddd',
                borderRadius: '4px'
              }} required={isCreateMode} />
                                    </div>}
                            </div>

                            <div style={{
            display: 'grid',
            gridTemplateColumns: '1fr 1fr',
            gap: '20px',
            marginBottom: '20px'
          }}>
                                <div>
                                    <label style={{
                display: 'block',
                marginBottom: '5px',
                fontWeight: 'bold'
              }}>ID текущей компании</label>
                                    <input type="text" value={editForm.company_id} onChange={e => setEditForm({
                ...editForm,
                company_id: e.target.value
              })} style={{
                width: '100%',
                padding: '8px',
                border: '1px solid #ddd',
                borderRadius: '4px'
              }} required />
                                </div>
                                <div>
                                    <label style={{
                display: 'block',
                marginBottom: '5px',
                fontWeight: 'bold'
              }}>ID компании-владельца</label>
                                    <input type="text" value={editForm.owner_company_id} onChange={e => setEditForm({
                ...editForm,
                owner_company_id: e.target.value
              })} style={{
                width: '100%',
                padding: '8px',
                border: '1px solid #ddd',
                borderRadius: '4px'
              }} placeholder="Пусто = совпадает с текущей" />
                                </div>
                            </div>

                            <div style={{
            display: 'grid',
            gridTemplateColumns: '1fr 1fr',
            gap: '20px',
            marginBottom: '20px'
          }}>
                                <div>
                                    <label style={{
                display: 'block',
                marginBottom: '5px',
                fontWeight: 'bold'
              }}>ID пользователя-владельца</label>
                                    <input type="text" value={editForm.owner_user_id} onChange={e => setEditForm({
                ...editForm,
                owner_user_id: e.target.value
              })} style={{
                width: '100%',
                padding: '8px',
                border: '1px solid #ddd',
                borderRadius: '4px'
              }} />
                                </div>
                                <div>
                                    <label style={{
                display: 'block',
                marginBottom: '5px',
                fontWeight: 'bold'
              }}>Статус</label>
                                    <select value={editForm.is_active} onChange={e => setEditForm({
                ...editForm,
                is_active: e.target.value === 'true'
              })} style={{
                width: '100%',
                padding: '8px',
                border: '1px solid #ddd',
                borderRadius: '4px'
              }}>
                                        <option value="true">Активен</option>
                                        <option value="false">Приостановлен</option>
                                    </select>
                                </div>
                            </div>

                            <div style={{
            display: 'flex',
            gap: '10px',
            marginTop: '30px'
          }}>
                                <button type="submit" style={{
              flex: 2,
              padding: '12px',
              background: '#27ae60',
              color: 'white',
              border: 'none',
              borderRadius: '6px',
              cursor: 'pointer',
              fontWeight: 'bold'
            }}>
                                    {isCreateMode ? 'Создать кабинет' : 'Сохранить изменения'}
                                </button>
                                <button type="button" onClick={() => {
              setEditingItem(null);
              setIsCreateMode(false);
            }} style={{
              flex: 1,
              padding: '12px',
              background: '#95a5a6',
              color: 'white',
              border: 'none',
              borderRadius: '6px',
              cursor: 'pointer'
            }}>
                                    Отмена
                                </button>
                            </div>
                        </form>
                    </div>
                </div>}

            <div style={{
      background: 'white',
      borderRadius: '12px',
      boxShadow: '0 4px 6px rgba(0,0,0,0.05)',
      overflow: 'hidden'
    }}>
                <table style={{
        width: '100%',
        borderCollapse: 'collapse'
      }}>
                    <thead style={{
          background: '#fcfcfc',
          borderBottom: '2px solid #eee'
        }}>
                        <tr>
                            <th style={{
              padding: '15px',
              textAlign: 'left'
            }}>Кабинет</th>
                            <th style={{
              padding: '15px',
              textAlign: 'center'
            }}>Тип</th>
                            <th style={{
              padding: '15px',
              textAlign: 'left'
            }}>Данные API</th>
                            <th style={{
              padding: '15px',
              textAlign: 'center'
            }}>Статус</th>
                            <th style={{
              padding: '15px',
              textAlign: 'right'
            }}>Действия</th>
                        </tr>
                    </thead>
                    <tbody>
                        {loading && <tr><td colSpan="5" style={{
              padding: '40px',
              textAlign: 'center'
            }}>Загрузка данных...</td></tr>}
                        {!loading && accounts.length === 0 && <tr><td colSpan="5" style={{
              padding: '40px',
              textAlign: 'center'
            }}>Кабинеты не найдены</td></tr>}
                        {filterBySearch(accounts, searchTerm).map(acc => <tr key={acc.id} style={{
            borderBottom: '1px solid #f5f5f5'
          }}>
                                    <td style={{
              padding: '15px'
            }}>
                                        <EntityCell
                                            name={acc.account_name}
                                            owner={acc.owner_email}
                                            note={acc.payer_name ? `плательщик: ${acc.payer_name}` : null}
                                            id={acc.id}
                                        />
                                    </td>
                                    <td style={{
              padding: '15px',
              textAlign: 'center'
            }}>
                                        <span style={{
                padding: '4px 10px',
                borderRadius: '20px',
                fontSize: '12px',
                fontWeight: 'bold',
                background: getTypeColor(acc.marketplace_type),
                color: 'white',
                textTransform: 'uppercase'
              }}>
                                            {getTypeLabel(acc.marketplace_type)}
                                        </span>
                                    </td>
                                    <td style={{
              padding: '15px'
            }}>
                                        <div style={{
                fontSize: '12px'
              }}>SellerID: {acc.seller_id || '—'}</div>
                                        <div style={{
                fontSize: '12px'
              }}>ClientID: {acc.client_id || '—'}</div>
                                    </td>
                                    <td style={{
              padding: '15px',
              textAlign: 'center'
            }}>
                                        {acc.is_active !== false ? <span style={{
                color: '#27ae60'
              }}>● Активен</span> : <span style={{
                color: '#e74c3c'
              }}>● Приостановлен</span>}
                                    </td>
                                    <td style={{
              padding: '15px',
              textAlign: 'right'
            }}>
                                        <button onClick={() => handleEdit(acc)} style={{
                marginRight: '10px',
                padding: '6px 12px',
                borderRadius: '4px',
                border: '1px solid #3498db',
                color: '#3498db',
                background: 'white',
                cursor: 'pointer'
              }}>
                                            Настроить
                                        </button>
                                        <button onClick={() => handleDelete(acc.id)} style={{
                padding: '6px 12px',
                border: 'none',
                color: '#e74c3c',
                background: 'transparent',
                cursor: 'pointer'
              }}>
                                            Удалить
                                        </button>
                                    </td>
                                </tr>)}
                    </tbody>
                </table>
            </div>
        </div>;
}
export default AdminMarketplaces;
